module.exports = __webpack_public_path__ + "static/media/footer_logo.27122e1a.svg";